//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
import * as schedule from '@/api/schedule';
var DEFAULT_STRATEGIES = [{
  label: '轮询调度',
  value: 'ROUND_ROBIN',
  desc: '节点轮流执行任务，确保实例公平调度。'
}, {
  label: '权重轮询',
  value: 'WEIGHTED',
  desc: '按照节点权重比例执行，适合差异化机器配置。'
}, {
  label: '分片广播',
  value: 'SHARDING',
  desc: '所有节点均执行一次，可结合分片序号拆分数据。'
}];
var createFormData = function createFormData() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    jobId: payload.jobId || 0,
    beanName: payload.beanName || '',
    cronExpression: payload.cronExpression || '',
    methodName: payload.methodName || '',
    params: payload.params || '',
    remark: payload.remark || '',
    dispatchStrategy: payload.dispatchStrategy || 'ROUND_ROBIN'
  };
};
export default {
  name: 'creatClassify',
  props: {
    editData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    strategyOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  // computed: {
  //   ...mapGetters(['adminProductClassify']),
  // },
  data: function data() {
    return {
      loading: false,
      loadingFrom: false,
      rules: {
        dispatchStrategy: [{
          required: true,
          message: '请选择调度策略',
          trigger: 'change'
        }]
      },
      dataForm: createFormData(this.editData)
    };
  },
  watch: {
    editData: {
      handler: function handler(val) {
        this.dataForm = createFormData(val);
      },
      deep: true
    }
  },
  computed: {
    availableStrategyOptions: function availableStrategyOptions() {
      return this.strategyOptions.length ? this.strategyOptions : DEFAULT_STRATEGIES;
    },
    selectedStrategyHint: function selectedStrategyHint() {
      var _this = this;
      var current = this.availableStrategyOptions.find(function (item) {
        return item.value === _this.dataForm.dispatchStrategy;
      });
      return current ? current.desc : '节点轮流执行任务，确保实例公平调度。';
    }
  },
  methods: {
    handleClose: function handleClose() {
      var _this2 = this;
      this.$nextTick(function () {
        if (_this2.$refs['dataForm']) {
          _this2.$refs['dataForm'].resetFields();
        }
        _this2.dataForm = createFormData();
        _this2.$emit('closeModel');
      });
    },
    onClose: function onClose() {
      if (this.$refs['dataForm']) {
        this.$refs['dataForm'].resetFields();
      }
      this.dataForm = createFormData();
      this.$emit('closeModel');
      this.loading = false;
      this.$emit('getList');
      this.dialogVisible = false;
    },
    onsubmit: function onsubmit(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          !_this3.dataForm.jobId ? schedule.scheduleJobAdd(_this3.dataForm).then(function (res) {
            _this3.$message.success('操作成功');
            _this3.onClose();
          }).catch(function () {
            _this3.loading = false;
          }) : schedule.scheduleJobUpdate(_this3.dataForm).then(function (res) {
            _this3.$message.success('操作成功');
            _this3.onClose();
          }).catch(function () {
            _this3.loading = false;
          });
        } else {
          return false;
        }
      });
    }
  }
};